import clsx from "clsx";
import { FC, ReactNode } from "react";
import { useIsMobile } from "../../hooks/useBreakpoint";
import { useCardCollapse } from "./MobileCard";

export const PageIntro: FC<{
  as?: "p" | "h2";
  className?: string;
  children: ReactNode;
}> = ({ as: Tag = "p", className, children }) => {
  const isMobile = useIsMobile();
  const { collapsed, toggle } = useCardCollapse();

  if (!isMobile) return <Tag className={className}>{children}</Tag>;

  return (
    <div className={clsx("page-intro", { "page-intro--collapsed": collapsed })}>
      <Tag className="page-intro__text fs-16 lh-24 fw-400 mb-0">{children}</Tag>
      <button
        type="button"
        aria-expanded={!collapsed}
        onClick={toggle}
        className="transparent page-intro__toggle fs-12 fw-500 condensed color-primary1 hover-primary2 pointer nowrap">
        {collapsed ? "See more" : "See less"}
      </button>
    </div>
  );
};
